// CSS styles for use with the global site header
import { css } from "@emotion/react"
import {
  focusStyles,
  focusStylesDark,
  transition
} from "./index"


import {
  NeutralIconDefault,
  PrimaryIconDefault,
} from "../../tokens/js/light"

import {
  NeutralIconDefault as NeutralIconDefaultDark,
  PrimaryIconDefault as PrimaryIconDefaultDark,
} from "../../tokens/js/dark"

// Apply to a <button> that has an <svg> (and nothing else) as a child
export const iconButtonStyles = (themeName:string = "light") => css`
  appearance: none;
  border: none;
  background: transparent;
  text-align: center;
  line-height: 0;
  color: ${themeName === "light" ?  NeutralIconDefault : NeutralIconDefaultDark};
  transition: ${transition()};
  cursor: pointer;
  
  &:hover,
  &:focus {
    color: ${themeName === "light" ? PrimaryIconDefault : PrimaryIconDefaultDark};       
  }

  &:focus-visible {
    ${themeName === "light" ? focusStyles : focusStylesDark}
  }

  svg path,
  svg g path {
    fill: currentColor;
    transition: inherit;
  }
`;
